import { Link } from 'gatsby';
import React from 'react';
import { hasRichTextContent, hasText } from '../../../utils/general/builder';

export function DynamicHeroCta({ buttonLink, buttonLabel }) {
    return (
        <Link className="milan-btn milan-cta-btn" to={buttonLink}>
            {buttonLabel}
        </Link>
    );
}

export function DynamicHeroContent({
    typefaceLogo,
    logoImageAlt,
    heading,
    headingColor = 'milan-text-primary',
    disclaimerColor = 'milan-text-navy',
    disclaimerLinkText,
    disclaimerTextPromise,
    richTextContent,
    buttonLink,
    buttonLabel,
    setShowSignUpModal,
    footerText,
    footerTextColor = 'milan-text-primary',
    showButton = true,
}) {
    const hasContent = hasRichTextContent(richTextContent);

    return (
        <div className="col">
            {/* only hide on md */}
            {typefaceLogo && (
                <figure className="pb-4 position-relative z-index-100 text-center d-none d-lg-block">
                    <img
                        id="graphic"
                        src={typefaceLogo}
                        alt={logoImageAlt}
                        className="img-fluid w-auto"
                        style={{ maxHeight: '250px' }}
                    />
                </figure>
            )}
            {hasText(heading) && (
                <h1 className={`${headingColor} smalltitle text-center ${!hasContent ? 'pb-0' : ''}`}>{heading}</h1>
            )}
            {hasContent && (
                <div
                    className="text-start milan-text-primary milan-rich-text"
                    dangerouslySetInnerHTML={{ __html: richTextContent }}
                />
            )}
            {/* Button - Book My Consultation. Not rendered on mobile/tablet, where the hero puts it
                directly under the image, or when no link/label is configured */}
            {showButton && (
                <div className="my-4 text-center">
                    <DynamicHeroCta {...{ buttonLink, buttonLabel }} />
                </div>
            )}
            {/* Modal - Stay up to date section */}
            {(hasText(disclaimerLinkText) || hasText(disclaimerTextPromise)) && (
                <p className={`${disclaimerColor} mb-lg-0 milan-fp text-start`}>
                    {hasText(disclaimerLinkText) && (
                        <>
                            <span
                                className="text-decoration-underline pointer"
                                onClick={() => setShowSignUpModal(true)}
                            >
                                <strong>{disclaimerLinkText}</strong>
                            </span>{' '}
                        </>
                    )}
                    {hasText(disclaimerTextPromise) && <span>{disclaimerTextPromise}</span>}
                </p>
            )}
            {hasText(footerText) && (
                <p className={`${footerTextColor} mb-lg-0 mt-2 milan-fp text-start`}>{footerText}</p>
            )}
        </div>
    );
}
